// ============================================================
// The boundary readers the kill-team's stored records share (the Tactics item
// and the kill-team block on a sheet): text cut to length, integers clamped,
// and optional fields written only when present.
//
// Pure. Zero React dependency.
// ============================================================

export type Raw = Record<string, unknown>;

const MAX_NAME = 60;
export const MAX_TEXT = 600;

export const text = (value: unknown, max = MAX_NAME): string =>
  typeof value === 'string' ? value.trim().slice(0, max) : '';

/** A finite number rounded and clamped to `lo..hi`; null for anything else. */
export const int = (value: unknown, lo: number, hi: number): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? Math.min(hi, Math.max(lo, Math.round(value))) : null;

/** Zero as none: a field that counts only when it is not 0 (a bonus, an adjustment) is never stored as 0. */
export const nonZero = (n: number | null): number | null => (n === 0 ? null : n);

/** An optional field, written only when present (gotcha 2: never an undefined field on the wire). */
export const optional = <K extends string, V>(key: K, value: V | null | '' | undefined) =>
  (value === null || value === undefined || value === '' ? {} : { [key]: value }) as Partial<Record<K, V>>;
